module.exports = __webpack_public_path__ + "img/ama_middle.ec984e88.png";